import * as React from "react";
import {DraggableSyntheticListeners, useDraggable} from "@dnd-kit/core";
import {FormatDuration} from "../../../../Formatting";
import {AsperaStatusIcon, DeleteStopRemoveIconButton} from "../../../Actions/AsperaStatusButtonIcon";
import {AudioResourceDefinitionIcon} from "../../../../StatusIcons/TrackStatusIcon";
import {Resource} from "../../../../api";
import {AudioInfo} from "../../../AudioInfo";

export interface Props {
    audioResource: Resource;
    isOverlay?: boolean;
    isMapped? :boolean;
    allowEdits?: boolean;
    hideTypeIcon?: boolean;
    projectId: string;
}

export interface DraggableProps {
    children?: React.ReactNode;
    listeners?: DraggableSyntheticListeners;
}

export const AudioResource = (props: Props & DraggableProps & React.HTMLAttributes<HTMLTableRowElement>) => {

    const {attributes, listeners, setNodeRef} = useDraggable({id: props.audioResource.id!});
    return (
        <>
            <tr key={props.audioResource.id}
                aria-label={props.isOverlay ? `dragging ${ props.audioResource.filename}` : `resource ${ props.audioResource.filename}`}
                className={props.className} ref={setNodeRef} {...listeners} {...attributes}>
                <td className={"hidden"} />
                <td key={"filename"} className={"word-break"} colSpan={2}> {props.audioResource.filename} </td>
                <AudioInfo audioResource={props.audioResource} />
                <td key={"fillerAfter"} />
                <td key={"duration"} className={"numeric"}> {FormatDuration(props.audioResource.audioInfo?.duration ?? 0)} </td>
                <td className={"iconic"} width={10}>
                    {
                        props.hideTypeIcon ? null : <AudioResourceDefinitionIcon resource={props.audioResource} />
                    }
                </td>
                <td className={"iconic"}>
                    <AsperaStatusIcon projectId={props.projectId} resource={props.audioResource} />
                </td>
                <td className={"iconic"} width={10}>
                    {props.allowEdits ?
                        <DeleteStopRemoveIconButton isMapped={props.isMapped} resource={props.audioResource} />
                        : null}
                </td>
            </tr>
            <tr className={"shift-hidden"}>
                <td colSpan={6}> localPath: { props.audioResource.localPath} </td>
            </tr>
            <tr className={"shift-hidden"}>
                <td colSpan={6}> uploadStatus: { props.audioResource.uploadStatus} </td>
            </tr>
            <tr className={"shift-hidden"}>
                <td colSpan={6}> resourceId: { props.audioResource.id} </td>
            </tr>
            <tr className={"shift-hidden"}>
                <td colSpan={6}> s3path: {props.audioResource.s3Path} </td>
            </tr>
        </>
    );
};
